import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrincipalComponent } from './page/principal/principal.component';
import { CoreModule } from '@app/core/core.module';
import { FeaturesRoutingModule } from './features-routing.module';
import { SharedModule } from '@app/shared/shared.module';
import { TopBarModule } from './common/top-bar/top-bar.module';

@NgModule({
  declarations: [
    PrincipalComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    TopBarModule,
    SharedModule,
    FeaturesRoutingModule
  ],
  exports: [
    PrincipalComponent
  ]
})
export class FeaturesModule { }

